export default {"src":"/_next/static/media/edo.82f0b928.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};